import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent, setUserId, setUserProperties } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBrSBvO0oNk5Cq1Q0GodivHVJneg7TyPUA",
  authDomain: "kimbccorp-dashboard.firebaseapp.com",
  projectId: "kimbccorp-dashboard",
  storageBucket: "kimbccorp-dashboard.firebasestorage.app",
  messagingSenderId: "433553999470",
  appId: "1:433553999470:web:6bb9d5ed1b4d26e654c87f",
  measurementId: "G-1HXHWTYM6W",
};

const app = initializeApp(firebaseConfig);

// Public e-sign links carry the signing token in the URL, so never start analytics there
// (automatic page_view events would send the full URL).
const isESignDocumentPage =
  typeof window !== "undefined" && window.location.pathname.startsWith("/e-sign/");

const analyticsPromise =
  typeof window !== "undefined" && !isESignDocumentPage
    ? isSupported().then((supported) => (supported ? getAnalytics(app) : null))
    : Promise.resolve(null);

const shouldEnableAnalyticsDebug = () =>
  typeof window !== "undefined" &&
  (process.env.NODE_ENV !== "production" || window.location.hostname === "localhost");

const trackAnalyticsEvent = async (eventName, eventParams = {}) => {
  try {
    const analytics = await analyticsPromise;
    if (!analytics) {
      console.log("Firebase analytics is not supported in this browser.");
      return;
    }

    if (eventParams.app_user_id) {
      setUserId(analytics, String(eventParams.app_user_id));
    }

    if (eventParams.user_name) {
      setUserProperties(analytics, {
        user_name: String(eventParams.user_name),
      });
    }

    const params = {
      ...eventParams,
      ...(shouldEnableAnalyticsDebug() ? { debug_mode: true } : {}),
    };

    logEvent(analytics, eventName, params);
    console.log("Firebase analytics event sent:", eventName, params);
  } catch (error) {
    console.log("Firebase analytics event failed", error);
  }
};

export { app, analyticsPromise, trackAnalyticsEvent };
